import type { HeadersOptionType } from '@/uTypes/api'
import type { CouponUsageScope } from '@/uTypes/order/api'

/**
 * 쿠폰 usageScope별 노출 규칙
 * - USIMSA: 일반 화면에서만 노출 ([partners] 경로에서는 숨김)
 * - PARTNERS: 이 저장소에서는 항상 숨김
 * - AFFILIATE: [partners] 경로이면서 isThreeHoursChannel 일 때만 노출
 */
export const useCouponScope = () => {
  const route = useRoute()
  const { partnerInfo } = storeToRefs(usePartnerStore())

  const isVisibleCouponScope = (usageScope: CouponUsageScope) => {
    const isPartnersRoute = !!route.params.partner

    if (usageScope === 'USIMSA') return !isPartnersRoute
    if (usageScope === 'AFFILIATE') return isPartnersRoute && !!partnerInfo.value?.isThreeHoursChannel
    return false
  }

  /**
   * 쿠폰/주문 API에 붙일 `x-partners-key` 헤더
   * - [partners] 경로이면서 isThreeHoursChannel 일 때만 값이 있다 (그 외에는 빈 객체 → USIMSA 쿠폰 기준)
   * - 값은 채널 code가 아니라 `channel.domain`이다
   * - checkout/coupons에서 AFFILIATE 쿠폰을 보여줬다면 주문 생성 API에도 같은 헤더를 보내야 한다
   * - V3 주문(group)은 헤더 대신 body의 channelId로 scope를 검증한다
   */
  const getPartnersKeyHeader = (): HeadersOptionType => {
    const domain = partnerInfo.value?.domain
    if (!route.params.partner || !partnerInfo.value?.isThreeHoursChannel || !domain) return {}

    return { 'x-partners-key': domain }
  }

  return { isVisibleCouponScope, getPartnersKeyHeader }
}
